import apiClient from './client'
import type { MarkerNotification, MarkerNotificationInbox } from '../types/markerNotification.types'

export const fetchMarkerNotifications = async (): Promise<MarkerNotificationInbox> => {
    const response = await apiClient.get('/marker-notifications')
    return response.data.data
}

export const fetchMarkerNotificationHistory = async (): Promise<MarkerNotification[]> => {
    const response = await apiClient.get('/marker-notifications/history')
    return response.data.data
}

export const dismissMarkerNotification = async (id: number): Promise<void> => {
    await apiClient.post(`/marker-notifications/${id}/dismiss`)
}

export const resolveMarkerNotification = async (id: number, note?: string): Promise<void> => {
    await apiClient.post(`/marker-notifications/${id}/resolve`, { note: note?.trim() || null })
}
